<template>
  <div class="priority-matrix-node">
    <ChartHeader
      :value="value"
      :display-chart="displayChart"
      @set-display-chart="setDisplayChart"
    />
    <div class="priority-matrix-chart-container">
      <svg v-show="displayChart" ref="chart" class="pigeondoc-chart priority-matrix-chart"></svg>
      <PriorityMatrixTable :value="value" v-show="!displayChart" />
    </div>
  </div>
</template>

<script>
import ChartHeader from '../ChartHeader/ChartHeader.vue';
import PriorityMatrixTable from './PriorityMatrixTable.vue';
import priorityMatrixMixin from './priorityMatrixMixin.js';

export default {
  name: 'PriorityMatrix',
  mixins: [priorityMatrixMixin],
  components: {
    ChartHeader,
    PriorityMatrixTable,
  },
  data() {
    return {
      displayChart: true,
    };
  },
  methods: {
    setDisplayChart(value) {
      this.displayChart = value;
    },
  },
};
</script>

<style>
.priority-matrix-node {
  margin: 4rem 0;
}

.priority-matrix-chart-container {
  margin: 0 5%;
}

.priority-matrix-chart-container svg {
  width: 100%;
}

.trimmed-label:hover .trimmed-label-flyout {
  visibility: visible;
}

.trimmed-label-flyout {
  visibility: hidden;
}

.prio-matrix__quadrant-label {
  font-weight: bold;
  font-size: 0.9em;
}
</style>
